import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

/*
  A second `VisibleBeforeDate` used to live here. It was unused -- every menu
  imports the working one from ./VisibilityBeforeAfterDate -- and its condition
  was inverted by operator precedence, so an expired deadline still rendered its
  children. Removed rather than repaired: the functional implementation already
  exists. See docs/TEST-FINDINGS.md F-05.
*/

export const VisibleOnlyToRoles = ({ roles = [], children = null }) => {
    const _userRoles = useSelector(state => state.account.roles || [])
    const _isPermitted = _userRoles.some(r => roles.includes(r))
    return _isPermitted ? children : null
}

export const VisibleOnlyToCaptureAdmin = ({ children }) => <VisibleOnlyToRoles roles={['CaptureAdmin']}>{children}</VisibleOnlyToRoles>
export const VisibleOnlyToCinderellaAdmin = ({ children }) => <VisibleOnlyToRoles roles={['CinderellaAdmin']}>{children}</VisibleOnlyToRoles>
export const VisibleOnlyToEliminatorAdmin = ({ children }) => <VisibleOnlyToRoles roles={['EliminatorAdmin']}>{children}</VisibleOnlyToRoles>
export const VisibleOnlyToFootballAdmin = ({ children }) => <VisibleOnlyToRoles roles={['FootballAdmin']}>{children}</VisibleOnlyToRoles>
export const VisibleOnlyToOscarsAdmin = ({ children }) => <VisibleOnlyToRoles roles={['OscarsAdmin']}>{children}</VisibleOnlyToRoles>
